export default __webpack_public_path__ + "static/media/funeralrites.9632d555.png";